/**
 * Loose email-shape check — not full RFC 5322 validation, just enough to
 * catch an obviously malformed address before it's submitted as free text
 * (e.g. Section 2's instructor-of-record email, which has no <form> submit
 * to trigger the browser's own type="email" validation).
 */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
